import React, { useState, useEffect, memo } from 'react';
import Routes from './Routes';
import AxiosServices from './services/AxiosServices';
import Loader from './ui/Loader';
import Error from './ui/Error';
import Singleton from './core/singleton';
import isEmptyObject from './utils/isEmptyObject';

/** the main entrance of the SPA */
const App = () => {
    /** we got to get the language first */
    const [lngDictionnary, setLngDictionnary] = useState({});
    const [error, setError] = useState(null);
    /** if we finally got a dictionnary we can return the Routes of the spa */
    const CrewAppContainer = () => (isEmptyObject(lngDictionnary)) ? <Loader /> : <Routes />
    const getTranslation = () => {
        setError(null);
        /** basic use of the axios service */
        AxiosServices.translationsByLng()
            .then((result) => {
                let { data } = result;
                let crewAppLng = (typeof (data["crew-app"]) !== "undefined") ? data["crew-app"] : data;
                /** globally set the language with the Singleton */
                Singleton.getInstance().setDictionnary(crewAppLng);
                /** Ask react for a render */
                setLngDictionnary(crewAppLng);
            }).catch(error => {
                setError(error);
            })
    }
    /** Component did mount */
    useEffect(() => getTranslation(), []);
    return <div className="crew-app-wrapper">
        <CrewAppContainer />
        {
            (error !== null) &&
            <Error response={error}>
                <h1>{error.name} <i className="fas fa-bug"></i></h1>
                <p><strong>{error.message}</strong></p>
                <button
                    onClick={() => getTranslation()} className="btn btn-primary">Try again <i className="fas fa-history"></i>
                </button>
            </Error>
        }
    </div>
}
export default memo(App);